"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockNodeDependencies = void 0;
var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");
var _dependenciesResultSetGenerated = require("./dependenciesResultSet.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var BlockNodeDependencies = exports.BlockNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  ResultSetDependencies: _dependenciesResultSetGenerated.ResultSetDependencies,
  createBlockNode: _factoriesAny.createBlockNode
};